import React from 'react';
import ReactDOM from 'react-dom';
import R from 'ramda';

import { subscribe } from 'subscribe-ui-event';

let DOC;
let WIN;

if (typeof window !== 'undefined') {
  DOC = document;
  WIN = window;
}

const DEFAULT_OPTIONS = {
  boundary: {
    top: 50,
    bottom: 50
  },
  renderInViewport: false
};

function detectViewport(ComponentToRender, options = DEFAULT_OPTIONS) {
  return class extends React.Component {
    constructor(props, context) {
      super(props, context);
      this._viewport = {};
      this.state = {
        isInViewport: false
      };
      this.checkViewport = this.checkViewport.bind(this);
      this.handleScroll = this.handleScroll.bind(this);
      this.handleScrollStart = this.handleScrollStart.bind(this);
      this.subscribe = this.subscribe.bind(this);
    }

    static displayName = 'viewportHOC';

    componentDidMount() {
      this.subscribe();
    }

    getPageScrollTop() {
      return DOC.body.scrollTop + DOC.documentElement.scrollTop;
    }

    getElementBoundingClientRect(e, payload) {
      const element = ReactDOM.findDOMNode(this);
      if (!element) {
        return;
      }
      const rect = element.getBoundingClientRect();
      // from subscribe-ui-event
      const pageScrollTop =
        R.path(['scroll', 'top'], payload) || this.getPageScrollTop();

      this._viewport.clientHeight = WIN.innerHeight;

      this._viewport.boundingClientReact = {
        top: rect.top + pageScrollTop,
        bottom: rect.bottom + pageScrollTop
      };

      return this._viewport.boundingClientReact;
    }

    subscribe() {
      if (!this._viewport.subscriptions) {
        const self = this;
        const options = {
          enableResizeInfo: true,
          enableScrollInfo: true
        };
        self._viewport.subscriptions = [
          subscribe('scroll', self.handleScroll, options),
          subscribe('scrollStart', self.handleScrollStart, options)
        ];

        setTimeout(() => {
          self.getElementBoundingClientRect();
          self.checkViewport();
        }, 0);
      }
    }

    handleScroll(e, payload) {
      const scrollTop =
        R.path(['scroll', 'top'], payload) || this.getPageScrollTop();
      this.checkViewport(scrollTop);
    }

    handleScrollStart(e, payload) {
      this.getElementBoundingClientRect.apply(this, arguments);
    }

    unsubscribe() {
      if (this._viewport.subscriptions) {
        this._viewport.subscriptions.forEach(subscription => {
          subscription.unsubscribe();
        });
        this._viewport.subscriptions = null;
      }
    }

    componentWillUnmount() {
      this.unsubscribe();
    }

    checkViewport(scrollTop) {
      const rect =
        R.path(['_viewport', 'boundingClientReact'], this) ||
        this.getElementBoundingClientRect();
      const pageScrollTop = scrollTop || this.getPageScrollTop();
      const clientHeight = this._viewport.clientHeight;
      const scrollBottom = pageScrollTop + clientHeight;
      const { boundary } = Object.assign({}, DEFAULT_OPTIONS, options);

      if (
        rect.top <= scrollBottom + boundary.top &&
        rect.bottom >= pageScrollTop + boundary.bottom
      ) {
        this.setState({ isInViewport: true });
        this.unsubscribe();
      }
    }
    render() {
      // Only render when in viewport
      if (options.renderInViewport) {
        if (!this.state.isInViewport) {
          return options.placeholder || <div />;
        }
        return <ComponentToRender {...this.props} />;
      }
      // pass viewport status
      return (
        <ComponentToRender
          {...this.props}
          isInViewport={this.state.isInViewport}
        />
      );
    }
  };
}

export default detectViewport;
